import { Helmet } from "react-helmet-async";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import ScrollToTopButton from "@/components/ScrollToTopButton";
import { Button } from "@/components/ui/button";
const Precos = () => {
  const plans = [
    {
      name: "Grátis",
      price: "R$ 0",
      period: "para sempre",
      description: "Perfeito para começar sua jornada de hábitos",
      features: [
        "Até 3 hábitos ativos",
        "1 sapo virtual",
        "Estatísticas básicas",
        "Lembretes diários",
      ],
      cta: "Começar Grátis",
      popular: false,
    },
    {
      name: "Pro",
      price: "R$ 19,90",
      period: "/mês",
      description: "Para quem quer resultados sérios",
      features: [
        "Hábitos ilimitados",
        "Sapos ilimitados",
        "Estatísticas avançadas",
        "Lagoas compartilhadas",
        "Desafios em grupo",
        "Suporte prioritário",
      ],
      cta: "Assinar Pro",
      popular: true,
    },
    {
      name: "Empresas",
      price: "Sob consulta",
      period: "",
      description: "Transforme a cultura da sua empresa",
      features: [
        "Tudo do Pro",
        "Painel administrativo",
        "Relatórios de equipe",
        "Integração com RH",
        "Onboarding dedicado",
        "SLA garantido",
      ],
      cta: "Falar com Vendas",
      popular: false,
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Preços e Planos | HabitFrog - Gamificação de Hábitos</title>
        <meta name="description" content="Conheça os planos do HabitFrog: Grátis, Pro e Empresas. Comece gratuitamente e evolua conforme suas necessidades. Transforme seus hábitos com gamificação." />
        <link rel="canonical" href="https://habitfrog.com/precos" />
      </Helmet>

      <Header />
      <ScrollToTopButton />

      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4">
          <header className="text-center max-w-3xl mx-auto mb-16">
            <h1 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-6">
              Planos para Cada Jornada
            </h1>
            <p className="text-xl text-muted-foreground">
              Comece grátis e evolua conforme seus hábitos crescem. Sem pegadinhas, sem compromisso.
            </p>
          </header>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {plans.map((plan) => (
              <div
                key={plan.name}
                className={`relative bg-card rounded-2xl p-8 border ${
                  plan.popular ? "border-primary shadow-lg scale-105" : "border-border"
                }`}
              >
                {plan.popular && (
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary text-primary-foreground text-sm font-semibold px-4 py-1 rounded-full">
                    Mais Popular
                  </span>
                )}
                <h2 className="text-2xl font-bold text-foreground mb-2">{plan.name}</h2>
                <div className="mb-4">
                  <span className="text-4xl font-bold text-foreground">{plan.price}</span>
                  <span className="text-muted-foreground">{plan.period}</span>
                </div>
                <p className="text-muted-foreground mb-6">{plan.description}</p>
                <ul className="space-y-3 mb-8">
                  {plan.features.map((feature) => (
                    <li key={feature} className="flex items-center gap-2 text-foreground/80">
                      <Check className="w-5 h-5 text-primary" />
                      {feature}
                    </li>
                  ))}
                </ul>
                <Button
                  className="w-full"
                  variant={plan.popular ? "default" : "outline"}
                  asChild
                >
                  <Link to="/auth">{plan.cta}</Link>
                </Button>
              </div>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Precos;
